'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _reduxConnect = require('redux-connect');

var _components = require('components');

var _contacts2 = require('selectors/contacts');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Page = require('components/Page/Page');

var _Page2 = _interopRequireDefault(_Page);

var _AddContactField = require('containers/Contacts/AddContactField/AddContactField');

var _AddContactField2 = _interopRequireDefault(_AddContactField);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _Hint = require('components/Hint/Hint');

var _Hint2 = _interopRequireDefault(_Hint);

var _GroupContactsHeadLine = require('components/GroupContacts/GroupContactsHeadLine/GroupContactsHeadLine');

var _GroupContactsHeadLine2 = _interopRequireDefault(_GroupContactsHeadLine);

var _BackButton = require('components/BackButton/BackButton');

var _BackButton2 = _interopRequireDefault(_BackButton);

var _Pagination = require('components/Pagination/Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _contacts3 = require('helpers/contacts');

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _GroupContactsListWrapper = require('components/GroupContacts/GroupContactsListWrapper/GroupContactsListWrapper');

var _GroupContactsListWrapper2 = _interopRequireDefault(_GroupContactsListWrapper);

var _GroupContactsDeleteButton = require('containers/Contacts/GroupContactsDeleteButton/GroupContactsDeleteButton');

var _GroupContactsDeleteButton2 = _interopRequireDefault(_GroupContactsDeleteButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./GroupContacts.scss');

var scroll = _reactScroll2.default.animateScroll;

var GroupContacts = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        groupId = _ref.params.groupId;

    var promises = [];
    groupId = Number(groupId); // eslint-disable-line no-param-reassign
    promises.push(dispatch(contactsActions.loadGroupContacts(groupId)).promise);
    promises.push(dispatch(contactsActions.loadContacts()).promise);
    promises.push(dispatch(contactsActions.loadGroups()).promise);
    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  var contactsEntities = (0, _contacts2.getFilteredGroupContactsPage)(state);
  return {
    group: (0, _contacts2.getGroup)(state),
    groupContactsCount: contactsEntities.count,
    groupContactsCountAll: contactsEntities.countAll,
    groupId: Number(ownProps.params.groupId),
    groupsListLoading: state.contacts.groupsListLoading,
    kw: state.contacts.groupContactsKw,
    page: state.contacts.groupContactsPage
  };
}, (0, _extends3.default)({}, contactsActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(GroupContacts, _Component);

  function GroupContacts() {
    (0, _classCallCheck3.default)(this, GroupContacts);
    return (0, _possibleConstructorReturn3.default)(this, (GroupContacts.__proto__ || (0, _getPrototypeOf2.default)(GroupContacts)).apply(this, arguments));
  }

  (0, _createClass3.default)(GroupContacts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.updateCheckedGroupContacts({});
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.updateCheckedGroupContacts({});
    }
  }, {
    key: 'onImport',
    value: function onImport() {
      var groupId = this.props.groupId;

      this.props.loadGroupContacts(groupId);
    }
  }, {
    key: 'onContactAdd',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(contact) {
        var _props, t, addContact, moveContactToGroup, groupId, showSuccessToastr;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, t = _props.t, addContact = _props.addContact, moveContactToGroup = _props.moveContactToGroup, groupId = _props.groupId;

                showSuccessToastr = function showSuccessToastr() {
                  return _toastr2.default.success(t('Contact added'));
                };

                if (!contact.id) {
                  _context.next = 7;
                  break;
                }

                moveContactToGroup({ contact: contact, groupId: groupId });
                showSuccessToastr();
                _context.next = 16;
                break;

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return addContact((0, _extends3.default)({}, contact, { groupId: groupId })).promise;

              case 10:
                showSuccessToastr();
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                console.log(_context.t0);

              case 16:
                return _context.abrupt('return', true);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function onContactAdd(_x) {
        return _ref2.apply(this, arguments);
      }

      return onContactAdd;
    }()
  }, {
    key: 'onPageChange',
    value: function onPageChange(_ref3) {
      var page = _ref3.page;

      this.props.setGroupContactsPage({ page: page });
      scroll.scrollToTop();
    }
  }, {
    key: 'onDelete',
    value: function onDelete() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$count = _ref4.count,
          count = _ref4$count === undefined ? 1 : _ref4$count;

      var t = this.props.t;

      _toastr2.default.success(t('{{count}} contacts deleted', { count: count }));
    }
  }, {
    key: 'deleteGroupContact',
    value: function deleteGroupContact(contact) {
      var _props2 = this.props,
          deleteGroupContact = _props2.deleteGroupContact,
          groupId = _props2.groupId;

      deleteGroupContact({ contact: contact, groupId: groupId });
      this.onDelete();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          t = _props3.t,
          groupId = _props3.groupId,
          kw = _props3.kw,
          group = _props3.group,
          groupsListLoading = _props3.groupsListLoading,
          page = _props3.page,
          groupContactsCount = _props3.groupContactsCount,
          groupContactsCountAll = _props3.groupContactsCountAll,
          filterGroupContacts = _props3.filterGroupContacts;


      return _react2.default.createElement(
        _Page2.default,
        { header: t('Group: {{groupName}}', { groupName: group.name }), className: styles.page },
        _react2.default.createElement(_BackButton2.default, { backUrl: '/contacts/groups', asBlock: true, className: 'margin-bottom-20' }),
        _react2.default.createElement(_components.Loader, { show: groupsListLoading, small: true, inline: true }),
        _react2.default.createElement(
          _Hint2.default,
          null,
          t('Manage your contacts in this group')
        ),
        _react2.default.createElement(
          'div',
          { className: styles.form },
          _react2.default.createElement(
            'h3',
            null,
            t('Add user')
          ),
          _react2.default.createElement(
            _Hint2.default,
            { small: true },
            t('The new contact will be added to the group.')
          ),
          _react2.default.createElement(
            'div',
            { className: styles.optionContainer },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h5',
                null,
                t('Option'),
                ' 1'
              ),
              _react2.default.createElement(
                _Hint2.default,
                { small: true },
                t('You can import recipients from csv file.')
              )
            ),
            _react2.default.createElement(_components.ContactsImportButton, { groupId: groupId, onImport: this.onImport, hintBefore: true })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.optionContainer },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h5',
                null,
                t('Option'),
                ' 2'
              ),
              _react2.default.createElement(
                _Hint2.default,
                { small: true },
                t('Enter email or contact.')
              )
            ),
            _react2.default.createElement(_AddContactField2.default, {
              groupId: groupId,
              onAdd: this.onContactAdd
            })
          )
        ),
        _react2.default.createElement(
          'h3',
          null,
          t('List of contacts in the group')
        ),
        _react2.default.createElement(_GroupContactsHeadLine2.default, {
          className: styles.headLine,
          count: groupContactsCountAll,
          kw: kw,
          filter: filterGroupContacts
        }),
        _react2.default.createElement(
          _Hint2.default,
          { small: true, className: 'margin-vert-10' },
          t('Select to remove contacts from Group')
        ),
        _react2.default.createElement(_GroupContactsListWrapper2.default, {
          onDelete: this.deleteGroupContact,
          onSelectionChange: this.onSelectionChange
        }),
        _react2.default.createElement(
          'div',
          { className: styles.bottomLine },
          _react2.default.createElement(_GroupContactsDeleteButton2.default, {
            className: styles.buttonContainer,
            groupId: groupId,
            onDelete: this.onDelete
          }),
          _react2.default.createElement(_Pagination2.default, {
            className: styles.pagination,
            count: groupContactsCount,
            limit: _contacts3.pageLimit,
            onChange: this.onPageChange,
            page: page,
            checkMaxPage: true
          })
        )
      );
    }
  }]);
  return GroupContacts;
}(_ClientSideComponent2.default), _class3.propTypes = {
  addContact: _propTypes2.default.func,
  deleteGroupContact: _propTypes2.default.func,
  filterGroupContacts: _propTypes2.default.func,
  group: _propTypes2.default.object,
  groupContactsCount: _propTypes2.default.number,
  groupContactsCountAll: _propTypes2.default.number,
  groupId: _propTypes2.default.number,
  groupsListLoading: _propTypes2.default.bool,
  kw: _propTypes2.default.string,
  loadGroupContacts: _propTypes2.default.func,
  moveContactToGroup: _propTypes2.default.func,
  page: _propTypes2.default.number,
  setGroupContactsPage: _propTypes2.default.func,
  t: _propTypes2.default.func,
  updateCheckedGroupContacts: _propTypes2.default.func
}, _class3.defaultProps = {
  checkedGroupContacts: [],
  groupContacts: [],
  groupContactsCount: 0,
  groupContactsCountAll: 0
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onImport', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onImport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onContactAdd', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onContactAdd'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPageChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPageChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteGroupContact', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteGroupContact'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = GroupContacts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/Groups/GroupContacts.js
// module id = 2151
// module chunks = 1